module.exports = __webpack_public_path__ + "static/media/NX_DATA_SOLID12.efafe0d0.png";